import { useTranslation } from 'react-i18next'
import { Link } from '@inertiajs/react'
import { RocketIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function EmptyDashboard() {
  const { t } = useTranslation('projects')

  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="rounded-full bg-muted p-4 mb-4">
        <RocketIcon className="h-8 w-8 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-semibold mb-1">{t('production.apps.noApps')}</h3>
      <p className="text-sm text-muted-foreground mb-4 max-w-sm">
        {t('production.apps.noAppsDescription')}
      </p>
      <Button asChild variant="outline">
        <Link href="/projects?filter=active">{t('production.apps.viewApps')}</Link>
      </Button>
    </div>
  )
}
